import Generate from "./Generate";

export default Generate;
